import { render, staticRenderFns } from "./viimg.vue?vue&type=template&id=9dc596b6&scoped=true&"
import script from "./viimg.vue?vue&type=script&lang=js&"
export * from "./viimg.vue?vue&type=script&lang=js&"
import style0 from "./viimg.vue?vue&type=style&index=0&id=9dc596b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc596b6",
  null
  
)

export default component.exports